import { Route, Routes } from 'react-router-dom';
import Logs from '../components/logs/logs.component';
import AddMids from '../components/mid/add-mid.component';
import ViewAllMids from '../components/mid/view-all-mids.component';
import CreateNewPos from '../components/pos/create-pos.component';
import ViewAllPOS from '../components/pos/view-all-pos.component';
import AdminBranchesPage from '../pages/admin-pages/admin-branches.page';
import AdminMerchantsPage from '../pages/admin-pages/admin-merchants.page';
import AdminPartnersPage from '../pages/admin-pages/admin-partners.page';
import AdminResellersPage from '../pages/admin-pages/admin-resellers.page';
import DashboardPage from '../pages/merchant-pages/dashboard.page';
import PartnerTransactionsPage from '../pages/merchant-pages/partner-transaction.page';
import PaymentLinksPage from '../pages/common-pages/payment-links.page';
import MissingPage from '../pages/common-pages/missing.page';
import UserManagement from '../components/user-management/user-management.component';

function PartnerRoutes() {
  return (
    <Routes>
      <Route path="/" />
      <Route path="dashboard" element={<DashboardPage />} />
      <Route path="partners" element={<AdminPartnersPage />} />
      <Route path="resellers" element={<AdminResellersPage />} />
      <Route path="merchants" element={<AdminMerchantsPage />} />
      <Route path="branches" element={<AdminBranchesPage />} />
      <Route path="create-payment-links" element={<PaymentLinksPage />} />
      <Route path="transactions" element={<PartnerTransactionsPage />} />
      <Route path="logs" element={<Logs />} />
      <Route path="users">
        <Route index element={<UserManagement />} />
      </Route>
      <Route path="mids">
        <Route index element={<ViewAllMids />} />
        <Route path="add" element={<AddMids />} />
      </Route>
      <Route path="pos">
        <Route index element={<ViewAllPOS />} />
        <Route path="create" element={<CreateNewPos />} />
      </Route>
      <Route path="*" element={<MissingPage />} />
    </Routes>
  );
}

export default PartnerRoutes;
